import { Price } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import {
  Image,
  LineItemNote,
  LineItemProps,
  OrderBox,
  OrderItemWrapper,
  SmartLink,
  Title,
} from '@components';
import { Box, Grid, Stack } from '@mui/material';
import { t } from '@translations';
import { getImageResizerUrl } from '@utils/images.utils';
import { formatPrice } from '@utils/price.utils';

export type OrderMobileLineItemProps = LineItemProps & {
  netPrice?: Price;
  totalNetPrice?: Price;
  quantity?: number;
};

export const OrderMobileLineItem = ({
  lineItem = {},
  quantity = 0,
  netPrice,
  totalNetPrice,
}: OrderMobileLineItemProps) => {
  const { name, url, productNo = '', imageUrl = '' } = lineItem;
  const resizedImageUrl = getImageResizerUrl(imageUrl, { width: 150, format: 'webp' });
  return (
    <Box sx={{ display: { xs: 'block', lg: 'none' }, height: '100%' }}>
      <OrderBox sx={{ height: '100%' }}>
        <OrderItemWrapper>
          <Grid container>
            <Grid item xs={3} sx={{ lineHeight: 0, pr: 2 }}>
              <Image image={resizedImageUrl} />
            </Grid>
            <Grid item xs={9}>
              <Stack spacing={0.25} mb={1}>
                <SmartLink href={url}>
                  <Title variant='h6' noDot>
                    {name}
                  </Title>
                </SmartLink>
                <Box sx={{ width: { xs: 'min-content', sm: 'auto' }, mt: 2 }}>
                  {t(TextCodes.Product.Details.ProductNumber, { productNo })}
                </Box>
                <Box>
                  {quantity} x {formatPrice(netPrice)} = {formatPrice(totalNetPrice)}
                </Box>
              </Stack>
              <LineItemNote lineItem={lineItem} />
            </Grid>
          </Grid>
        </OrderItemWrapper>
      </OrderBox>
    </Box>
  );
};
